module.exports = __webpack_public_path__ + "img/WF.9cbf71ee.svg";